module.exports = __webpack_public_path__ + "img/zero-state.ded7f94c.svg";